// extracted by mini-css-extract-plugin
export default {"wrapper":"TextV1_wrapper__5gDsm","inner":"TextV1_inner__Ycb3n","alignmentCenter":"TextV1_alignmentCenter__koYgO","tagline":"TextV1_tagline__suAod"};